import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ConnectShopifyPage = lazy(() => import('~/features/onboarding/pages/connect-shopify-screen'));

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/google/shopify',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectShopifyPage />
    </Suspense>
  ),
});
